import Checkbox from "@mui/material/Checkbox";
import { styled } from "@mui/material/styles";

const CustomizedComponent = styled(Checkbox)(({ theme }) => ({
  color: theme.palette.secondary.main,
  checked: {},
  disabled: {},
}));

const OmniCheckbox = props => {
  const { children, ...other } = props;
  return (
    <CustomizedComponent dividers="true" {...other}>
      {children}
    </CustomizedComponent>
  );
};

export default OmniCheckbox;
